import { render } from "./COIActionBarVendorCancellation.vue?vue&type=template&id=10b994b5"
import script from "./COIActionBarVendorCancellation.vue?vue&type=script&lang=js"
export * from "./COIActionBarVendorCancellation.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__